// extracted by mini-css-extract-plugin
export default {"EventFormsButton":"EventFormsButton-module-a596f41c8efb996a3439"};